import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  TravelApprovalLog,
  type TravelApprovalLogConstructor,
} from './TravelApprovalLog'
import { TravelApprovalLogActions } from '../enums/TravelApprovalLogActionEnum'

export const TravelApprovalLogConstructorFactory =
  Factory.Sync.makeFactory<TravelApprovalLogConstructor>({
    id: Factory.each(() => faker.random.number()),
    action: TravelApprovalLogActions.REQUEST,
    dateTime: Factory.each(() => faker.date.past().toISOString()),
    user: Factory.each(() => ({
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
    })),
    nextApprover: null,
    oldTravelBudget: Factory.each(() => faker.random.number()),
    newTravelBudget: Factory.each(() => faker.random.number()),
  })

export const TravelApprovalLogFactory = EntityFactory(
  TravelApprovalLog,
  TravelApprovalLogConstructorFactory
)
